import { createWithEqualityFn as create } from "zustand/traditional"

// Module-level store so the palette (mounted standalone) and its trigger
// (mounted inside AppNavigation, a separate React root) share open state.
export const useCommandPaletteStore = create(set => ({
  open: false,
  setOpen: open => set({ open })
}))
